/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
import { writable } from 'svelte/store';

export const pages = writable([]);

export function setPages(response) {
  pages.set(response);
}
